export enum ComponentType {
  BUTTON = 'button',
  INPUT = 'input',
  TEXT = 'text',
  IMAGE = 'image',
  CARD = 'card',
  LIST = 'list',
  PANEL = 'panel',
}

export interface Position {
  x: number;
  y: number;
}

export interface Size {
  width: number;
  height: number;
}

export interface FontStyles {
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
}

export interface ComponentStyles {
  backgroundColor?: string;
  borderRadius?: number;
  borderColor?: string;
  borderWidth?: number;
  padding?: number;
  textAlign?: 'left' | 'center' | 'right';
  fontSize?: number;
  fontColor?: string;
  fontStyles?: FontStyles;
}

export interface ComponentProperties {
  text: string;
  src?: string;
  value?: string;
  name: string;
  opacity?: number;
  zIndex?: number;
  isLocked?: boolean;
  styles?: ComponentStyles;
  visible?: boolean;
  parentId?: string;
  isContainer?: boolean;
  scrollable?: boolean;
  children?: string[];
}

export interface ComponentEvents {
  onClick: string;
  onHover: string;
  onDrag: string;
}

export interface CanvasComponent {
  id: string;
  type: ComponentType;
  position: Position;
  size: Size;
  properties: ComponentProperties;
  events: ComponentEvents;
}

export interface ProjectSettings {
  name: string;
  author: string;
  nickname: string;
}

export interface Project {
  settings: ProjectSettings;
  components: CanvasComponent[];
}

export interface CommunityProject extends Project {
  id: string;
  preview_url: string;
  created_at: string;
  updated_at: string;
  likes: number;
  downloads: number;
}

export type EasyCodeAction = 
  | { type: 'setValue'; targetId: string; value: string }
  | { type: 'setLabel'; targetId: string; text: string }
  | { type: 'setVisibility'; targetId: string; visible: boolean }
  | { type: 'luaAction'; action: string; data: Record<string, any> };